import { LOCATION_ID_LSK, SHOP_ID_LSK } from 'app.constants'

// an interface declaration to handle the window.shopId type:
declare global {
    interface Window {
        shopId: string | undefined
    }
}

//getShopId:
export const getShopId = () => {
    let id = ''
    try{
        id = localStorage.getItem(SHOP_ID_LSK) ?? ''
    }catch(e){
        id = window.shopId ?? ''
    }
    return id
}

//updateShopId:
export const updateShopId = (id: string | null) => {
    try{
        if(id){
            localStorage.setItem(SHOP_ID_LSK, id)
        }else{
            localStorage.removeItem(SHOP_ID_LSK)
        }
        localStorage.removeItem(LOCATION_ID_LSK)
    }catch(e){
        window.shopId = id ?? undefined
    }
}
